import Cookies from 'js-cookie'
import router from '@/routes'
import User from '@/models/User'

export default {
  namespaced: true,
  state: {
    user: {},
    loading: false,
    isAuthenticated: false,
    token: {
      accessToken: null,
      expiresIn: null,
      tokenType: 'Bearer',
      uuid: null
    },
    timestamp: new Date().getTime()
  },

  getters: {
    avatarThumb(state) {
      return state.user.avatar_thumb_url + '?timestamp=' + state.timestamp
    },

    isAdmin(state) {
      return Object.keys(state.user).length ? state.user.is_admin : false
    }
  },

  mutations: {
    setUser(state, user) {
      if (user instanceof User) {
        state.user = user
      } else {
        state.user = new User(user)
      }
    },

    setToken(state, token) {
      if (token) {
        Cookies.set('AUTH_TOKEN', token)
        state.token = token
        state.isAuthenticated = true
      }
    },

    clearToken(state) {
      Cookies.remove('AUTH_TOKEN')
      state.token = {
        accessToken: null,
        expiresIn: null,
        tokenType: 'Bearer',
        uuid: null
      }
      state.isAuthenticated = false
    },
    setLoading(state, payload) {
      state.loading = payload
    },

    changeTimestamp(state) {
      state.timestamp = new Date().getTime()
    }
  },

  actions: {
    init({ commit }) {
      const token = Cookies.getJSON('AUTH_TOKEN')
      commit('setToken', token)
    },

    async getAuthenticatedUser({ commit }) {
      commit('setLoading', true)
      return this.$api
        .get('/auth/me')
        .then(res => {
          commit('setUser', res.data.data)
          commit('setLoading', false)
        })
        .catch(err => {
          if (err.response.status === 401) {
            commit('clearToken')
            commit('setLoading', false)
            router.replace({ name: 'auth.login' })
          }
        })
    },

    logout({ commit }) {
      this.$api.post('/auth/logout').then(() => {
        commit('clearToken')
        router.replace({ name: 'auth.login' })
      })
    }
  }
}
